webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883f7ca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("T53c")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2b54d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("tGyY")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Olympic Review - Issue 90",
  "shortTitle": "",
  "description": "",
  "width": 800,
  "height": 900,
  "currentLanguage": "EN",
  "languages": [{
    code: "EN",
    text: "English",
    href: "http://olympicreview.touchlines.com/90"
  }, {
    code: "FR",
    text: "French",
    href: "http://revueolympique.touchlines.com/90"
  }],
  "basePath": "/90",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "http://olympicreview.touchlines.com/90/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": 'http://olympicreview.touchlines.com/90/static/_content/olympic-review-90-english.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:808px;left:658px;width:126px;height:77px;\">\n        <a href=\"https://www.olympic.org/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        setTimeout(function(){\n          addContentLinks();\n        }, 1000);\n      }\n\n      function onPageLeave() {\n        removeContentLinks();\n      }\n      ",
    "searchText": "OLYMPIC REVIEW  OLYMPIC OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT JANUARY-FEBRUARY-MARCH 2014 NUMBER 90  The Athletes’ Games Relive the thrilling highlights of the Sochi 2014 Olympic Winter Games, including awe-inspiring sporting performances, dazzling ceremonies and exciting new events  JANUARY FEBRUARY MARCH 2014 NUMBER 90  WWW.OLYMPIC.ORG  OLY040_P0001EDeng.indd 2  21/03/2014 12:01"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0002EDeng.indd 2  19/03/2014 14:44"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0002EDeng.indd 3  19/03/2014 14:44"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC REVIEW  CONTENTS OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT JANUARY-FEBRUARY-MARCH 2014  07 FOREWORD By IOC President Thomas Bach.  09 NEWS The latest news and events from around the Olympic Movement. EXECUTIVE BOARD  18 COVER STORY: FROM SOCHI WITH LOVE Olympic Review offers a day-by-day round-up of the incredible highlights from the Olympic Winter Games in Sochi, from the dazzling Opening Ceremony and the debut of new Olympic events to the record-breaking achievements of athletes such as Ole Einar Bjørndalen.  President Thomas Bach Vice-Presidents Nawal El Moutawakel, Craig Reedie, John Coates, Zaiqing Yu Members Sam Ramsamy, Gunilla Lindberg, Ching-Kuo Wu, René Fasel, Patrick Joseph Hickey, Claudia Bokel, Juan Antonio Samaranch Jr, Sergey Bubka, Willi Kaltschmitt Luján, Anita L. DeFrantz, Ugur Erdener OLYMPIC REVIEW  36 BEHIND THE LENS Relive the Games through the iconic photography of five IOC photographers who share their memories and highlights of Sochi 2014.  50 HOT. COOL...“OURS” Fans, officials, volunteers and athletes, including French freestyle skier Kevin Rolland and US figure skater Gracie Gold, reveal their best moments of the Sochi 2014 Winter Games.  62 DAZZLING DEBUTS Twelve new Olympic events took centre stage at the 2014 Winter Games, with the likes of snowboard slopestyle and women’s ski jumping capturing the imagination of fans and media alike.  70 THE FACES OF THE GAMES A 25,000-strong team of tireless volunteers deserve huge credit for their part in the smooth running of the 2014 Winter Games in Sochi. Olympic Review learns about their achievements and finds out exactly how their legacy will live on across Russia.  76 MY GAMES France’s Jean-Claude Killy reflects on his exceptional Olympic career, which included three Alpine skiing gold medals at the 1968 Winter Games in Grenoble.  79 OBITUARIES Olympians and figures from the Olympic Movement who have sadly passed away.  82 THE OLYMPIC SPIRIT Celebrating the sportsmanship of Dieter Speer, a member of the East German men’s biathlon 4×7.5km relay team in Sapporo.  Communications Director Mark Adams Editor-in-Chief Kathleen Di Giacomo French Edition Aurélie Eichler Spanish Edition Dolores Vázquez Production Agency Touchline Production Michael Stoneman, Glyn Wilmshurst Design John Paul Yetton, Liam Yeoh Image retouching Jason Dutch Sub Editors Laura Adcock Translation Denis Echard, Laura Nadal Obrador, Ros Schwartz Proofreading Libero Language Lab ISSN: 0377-192X Printed in the UK IMAGES Cover Image Getty Images Inside IOC; IOC/ Mine Kasapoglu; IOC/ Ian Jones; IOC/ Jason Evans; IOC/ John Huet; IOC/ Christopher Graythen; IOC/ Catherine Leutenegger; IOC/ Richard Juilliart; David Burnett; IOC/United Archives; Sochi 2014; Getty Images; AFP CONTACTS Please send your letters to: Olympic Review, IOC Department of Communications, Château de Vidy, 1007 Lausanne, Switzerland. website: www.olympic.org, email: olympicreview@olympic.org tel +41 (0)21 621 6111 fax +41 (0)21 621 6356 Olympic Review uses PEFC-certified paper stock sourced from sustainable managed forests. Olympic Review is published by the International Olympic Committee. The articles published in Olympic Review do not necessarily reflect the opinion of the International Olympic Committee. No articles may be reproduced without the permission of the IOC Department of Communications.  4 OLYMPIC REVIEW  OLY040_P0004EDeng.indd 04  21/03/2014 15:22"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC REVIEW 5  OLY040_P0004EDeng.indd 05  21/03/2014 15:22"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0006EDeng.indd 1  21/03/2014 15:27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "“Thank you very much dear Olympic athletes. You have inspired us for the last magnificent 17 days. You have excelled in your competitions. You have shared your emotions with us and the whole world. You have celebrated victory with dignity and accepted defeat with dignity. By living together under one roof in the Olympic Village you send a powerful message from Sochi to the world: the message of a society of peace, tolerance and respect. I appeal to everybody implicated in confrontation, oppression or violence: act on this Olympic message of dialogue and peace.” IOC President Thomas Bach at the Closing Ceremony of the XXII Olympic Winter Games  OLYMPIC REVIEW 7  OLY040_P0007EDeng.indd 7  21/03/2014 12:04"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0008EDeng.indd 1  24/03/2014 16:48"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "WORLD LEADERS ATTEND IOC PRESIDENT’S DINNER IN SOCHI  On the eve of the Sochi 2014 Opening Ceremony, the inaugural IOC President’s Dinner was held. On this occasion, President Bach welcomed 12 heads of state, four heads of government and representatives of the worlds of business, media, science, culture and sport. The heads of state, government and international organisations included President of the Russian Federation Vladimir Putin, United Nations Secretary-General Ban Ki-moon, President of the People’s Republic of China Xi Jinping, Prime Ministers Plamen Oresharski of Bulgaria, Najib Mikati of Lebanon, Algirdas Butkevicius of Lithuania and Abdelilah Benkirane of Morocco. Gymnast Larissa Latynina and legendary ice hockey goalkeeper Vladimir Tretiak were among the greatest Olympians present. Business representatives at the dinner included Coca-Cola CEO Muhtar Kent, Panasonic CEO Kazuhiro Tsuga, McDonalds CEO Donald Thompson, Omega CEO Stephen Urquhart, and the heads of Comcast/NBC and Russian television broadcasters Channel One, VGTRK and NTV. The first woman in space, cosmonaut Valentina Tereshkova, soprano Anna Netrebko and violinistturned-Alpine skier Vanessa Mae were also welcomed by President Bach. In his welcome speech, the IOC President said: “The purpose of this dinner is to show that the IOC is reaching out to society at large and is looking forward to an open dialogue with the worlds of politics, business, the media, science and culture. We want to share with you the Olympic spirit and the Olympic values [… ] just as the athletes are doing at this very moment in the Olympic Village next door. Even though they are competitors, they are sharing a meal and enjoying being together in the Olympic community.”  OLYMPIC CHAMPIONS ELECTED TO IOC ATHLETES’ COMMISSION Thirteen-time Winter Olympic medallist Ole Einar Bjørndalen, from Norway (biathlon), and fivetime Winter Olympic medallist Hayley Wickenheiser, from Canada (ice hockey), have been elected to the IOC Athletes’ Commission by their peers at the Sochi 2014 Olympic Winter Games for a term of eight years. A new Olympic record was set by the Sochi athletes after more than 80 per cent of them made their way to the voting booths. IOC President Thomas Bach said: “As one of the founding members of the IOC Athletes’ Commission, I very much appreciate the high participation in the vote. It shows the value that athletes place on being part of the decision-making process and helping to shape the future of the Olympic Movement.” Bjørndalen was elected with 1,087 votes, followed by Wickenheiser with 758. The two new members will  replace Rebecca Scott and Saku Koivu, who were elected to the Athletes’ Commission at the Turin Games in 2006 for a term of eight years each. Commission Chair Claudia Bokel said after the announcement: “The athletes are at the heart of the Olympic Games, and our Commission is  their voice in all decisions taken by the IOC. During the Games, our Commission members listened to the athletes’ concerns and opinions in all three Olympic Villages.” Above Wickenheiser (left) and Bjørndalen (centre) at the Sochi 2014 Closing Ceremony  BOKEL RE-ELECTED ATHLETES’ COMMISSION CHAIR At a meeting of the IOC Athletes’ Commission in Sochi, Claudia Bokel was re-elected as Chair of the Commission, which is the voice of the athletes within the IOC and the Olympic Movement. Bokel, a former fencer and silver medallist (team) at the Olympic Games in 2004, will also remain as a member of the IOC Executive Board. Angela Ruggiero was elected Vice-Chair. Ruggiero is an Olympic champion in ice hockey and has played more games for  Team USA than any other man or woman. Claudia Bokel said after the meeting: “I would like to thank my colleagues for their trust in my work, and am looking forward to continuing my mission of bringing athletes’ views to the attention of the right people in the Olympic Movement. “It is great to know that I can count on the continued support and valuable input of my Commission members for this important task.”  Below Commission Chair Claudia Bokel (left) and newly-elected Vice-Chair Angela Ruggiero  OLYMPIC REVIEW 9  OLY040_P0009EDeng.indd 9  21/03/2014 12:14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC SESSION ELECTS NEW VICEPRESIDENT AND EB MEMBER  The 126th Session elected Zaiqing Yu as IOC Vice-President and Ugur Erdener as an Executive Board member. It also elected Poul-Erik Høyer, Olympic badminton  champion and President of the Badminton World Federation (BWF), as an IOC member. Meanwhile, Beatrice Allen, Nicole Hoevertsz and HRH Prince Tunku Imran were re-elected as IOC  members by the Session. Above New IOC Vice-President Zaiqing Yu (left), Executive Board member Ugur Erdener (centre) and IOC member Poul-Erik Høyer  PANASONIC EXTENDS TOP PARTNERSHIP thrilled to be able to announce that we will continue to work with our long-term Partner Panasonic. Panasonic was one of the founding members of our global sponsorship programme, and is the first Partner to commit to continue its global sponsorship through 2024. This is a clear demonstration of Panasonic’s continuing belief in the Olympic values and the company’s global commitment to the Olympic Movement.” On 6 February in Sochi, the IOC announced that it had reached an agreement with Panasonic to extend its Worldwide TOP  Partnership until 2024, making Panasonic the first TOP Partner to sign until 2024. President Bach said: “We are  ATOS SIGNS NEW TOP PARTNERSHIP AGREEMENT The IOC has announced that it has reached an agreement with Atos to extend its Worldwide TOP Partnership through to 2020. Atos will provide Integration Services and Systems Management Services, Core Hosting Services and key Games-related applications and associated services for the XXIII Olympic Winter Games (2018) in PyeongChang and the Games of the XXXII Olympiad (2020) in Tokyo. Atos has been a key technology provider for the Olympic Movement since 1989, when the company provided services to the Barcelona 1992 Organising Committee. Atos became the Olympic Movement’s Worldwide Information Technology Partner in 2001, and recently supported the Organising Committee for the XXII Olympic Winter Games in Sochi, Russia, in 2014, and is already working with the Organising Committee for the Games of the XXXI Olympiad in Rio de Janeiro, Brazil, in 2016. IOC President Thomas Bach said: “Technology is critical to the success of each edition of the Olympic Games. We are delighted that we will be able to continue relying on Atos and its vast experience to deliver flawless, innovative IT services.” Below Atos became the Olympic Movement’s Worldwide Information Technology Partner in 2001  Left Panasonic is the first Worldwide TOP Partner to sign until 2024  10 OLYMPIC REVIEW  OLY040_P0009EDeng.indd 10  21/03/2014 12:14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014 GAMES COVERAGE SETS NEW BROADCAST RECORDS  The global broadcast of Sochi 2014 – both on television and digital platforms – set new records for an Olympic Winter Games, with more coverage on more channels than ever before. In total, 464 television channels around the world broadcast the Sochi 2014 Games, compared with 240 in Vancouver four years ago, while there were also more digital platforms offering coverage than at any previous Winter Games, with 155 websites and 75 apps showing events live from Russia. This also included the Olympic video player that Olympic Broadcasting Services launched, which provided fully integrated data, a news channel, live streams and on-demand video. Thanks to the increased number of channels and digital platforms, by the end of Sochi 2014 there were also more hours broadcast globally of Olympic events than any previous Winter Games, with over 100,000 hours broadcast around the world, compared with 57,000 for Vancouver 2010. There were more hours broadcast on television than ever before, with 42,000 hours in Sochi compared to 32,000 hours for Vancouver. For the first time in Olympic history, the amount of digital coverage also exceeded traditional television broadcasts, with 60,000 hours available on digital platforms.  TOKYO 2020 ESTABLISHES ORGANISING COMMITTEE The Tokyo Organising Committee of the Olympic and Paralympic Games (Tokyo 2020) has been formally established. The Committee will be responsible for ensuring the successful organisation of the  Games, and its establishment marks another major step on Tokyo’s Olympic journey. As well as the creation of the Committee, it was also announced that former Prime Minister of Japan, Yoshiro Mori, had been appointed as  President and Toshiro Muto as Chief Executive Officer of Tokyo 2020. IOC President Thomas Bach said: “We congratulate Tokyo 2020 on the establishment of their Organising Committee, and welcome the appointments of Yoshiro Mori as President of the Tokyo 2020 Organising Committee and Toshiro Muto as CEO. We look forward to working with both of them in the months and years ahead.” He continued: “As a former Prime Minister of Japan, sports administrator, avid sports fan, and member of the Tokyo 2020 bid team, Mr Mori’s experience will allow him to make an immediate impact on preparations for the 2020 Games and provide proper guidance to the newly formed team in Tokyo. We wish Mr Mori and Mr Muto great success in their new roles.” Left The Tokyo 2020 Organising Committee will be headed by former Prime Minister of Japan Yoshiro Mori (third from left)  PYEONGCHANG 2018 MARKS FOUR YEARS TO GO During the Sochi 2014 Winter Games, the PyeongChang Organising Committee for the 2018 Olympic Winter Games (POCOG) welcomed over 350 visitors and international press to PyeongChang House for an event to mark “Four Years To Go” until the Opening Ceremony of  the XXIII Olympic Winter Games. IOC President Thomas Bach, IOC Honorary President Jacques Rogge, IOC Coordination Commission Chair and Executive Board Member Gunilla Lindberg and Sochi 2014 President and CEO Dmitry Chernyshenko were in attendance to celebrate with  POCOG President Kim Jin-sun, Vice-President and Secretary General Moon Dong-hoo, and Korean Olympic Committee (KOC) President Kim Jung-haeng. Right IOC President Bach addresses over 350 guests at PyeongChang House in Sochi  OLYMPIC REVIEW 11  OLY040_P0009EDeng.indd 11  21/03/2014 12:14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0012EDeng.indd 1  24/03/2014 16:52"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "YOG ATHLETES STAR AT SOCHI 2014 OLYMPIC WINTER GAMES  More than 60 young athletes who took part in the inaugural Winter Youth Olympic Games (YOG) in Innsbruck in 2012 went on to compete on the Olympic stage, having qualified for the Sochi 2014 Olympic Winter Games. Many of them also enjoyed medal success in Russia. Among those to strike gold was short track speed skater Shim Suk-Hee, of the Republic of Korea, who topped the podium alongside her team-mates in the women’s 3,000m. The 17-year-old, who won two gold medals in Innsbruck, also won silver in the 1,500m and  bronze in the 1,000m in Sochi to cap a hugely impressive Olympic debut. “Being a YOG athlete is special,” she said. “We are trained well and we are taught well at the Youth Olympic Games; that is why we can handle success well, but failure even better.” German ski jumper Andreas Wellinger was another successful YOG graduate in Sochi, the 18-year-old winning a gold medal in the men’s team event. Russian figure skater Adelina Sotnikova, meanwhile, followed up the singles silver medal she won in  Innsbruck with gold in the women’s event in Sochi. Japan’s Taku Hiraoka also won a medal in Sochi, as he claimed bronze in the men’s snowboard halfpipe ahead of two-time Olympic champion Shaun White, of the USA. Other YOG athletes who put in impressive performances in Sochi included Switzerland’s David Hablützel, who finished fifth in the men’s snowboard halfpipe, Japan’s Sara Takanashi, who was fourth in the women’s ski jumping, and Miriam Kastlunger, who was part of the Austrian quartet which came seventh in the inaugural mixed luge relay.  It was not just young athletes who were able to bring their Innsbruck 2012 experience to bear in Sochi. The 2014 Winter Games also welcomed a host of Athlete Role Models, Young Ambassadors and Young Reporters, who had participated at the inaugural YOG. Above (Clockwise from top left) Japanese snowboarder Taku Hiraoka; German ski jumper Andreas Wellinger, Austrian luger Miriam Kastlunger; Japanese ski jumper Sara Takanashi; and Russian figure skater Adelina Sotnikova  OLYMPIC REVIEW 13  OLY040_P0013EDeng.indd 13  21/03/2014 12:16"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LILLEHAMMER 2016 LAUNCHES NEW EMBLEM Four young designers from the University College of Gjøvik in Norway were given the mission to create Lillehammer 2016’s Youth Olympic Games (YOG) emblem, which was unveiled recently. The four students from the university’s Media Design programme – Marianne Ågotnes, Anja Rullestad, Marte Stensrud and Live Andrea Sulheim – rose to the challenge by designing a clear, neat and subtle emblem that embodies Norwegian ideals. One of the young designers said: “I don’t think many students have started their working careers with Olympic deliveries.” The launch of this emblem is the first step by the Lillehammer 2016 YOG Organising Committee towards revealing the visual identity of the next Winter Youth Olympic Games. As the CEO of Lillehammer 2016, Tomas Holmestad commented: “There is also great interest in how the total visual profile for the Games will be. This will be launched during the coming winter.”  NEWS IN BRIEF IOC announces over 100 Young Ambassadors for Nanjing 2014 The IOC has announced a list of over 100 inspiring young people who will serve as Young Ambassadors for the Nanjing 2014 Youth Olympic Games (YOG). The list features active athletes, including Olympians and YOG alumni, sports coaches, students and young professionals, all aged between 18 and 25. Following the success of the programme during the first Summer YOG in Singapore, in 2010, and the first Winter YOG in Innsbruck, in 2012, the number of Young Ambassadors has increased from 30 and 33 respectively to 105 in Nanjing. As well as promoting the YOG and the Olympic values in their countries, the role of the Ambassadors will be to help the athletes of their national teams get the most out of their YOG experience.  NANJING 2014 MEDALS UNVEILED A young sports fan from Slovakia has been announced as the winner of the Nanjing 2014 Youth Olympic Games Medal Design Competition. The winning concept, entitled “Track of Winners”, was chosen from a pool of over 300 entries from more than 50 countries by a prestigious IOC jury, who described it as “modern, fresh and dynamic”. Speaking about his win, 23-yearold Matej Cicka (pictured below), said: “It was our school task to join this competition and design a medal. So I drew a lot of sketches and spoke with a teacher to choose the best one. “I was inspired by the athletes’ track, which, to me, means the base of the Youth Olympic Games. So  I put it into my concept and used different shapes to represent the winning athletes and the podium. And finally I called it the Track of Winners.” The judging panel comprised world-renowned designer Thomas Heatherwick, the man behind the iconic Olympic cauldron at the London 2012 Olympic Games; Youth Olympic Games 400m hurdles gold medallist Aurélie Chaboudez (FRA); Olympic short-track speed skating champion Yang Yang (CHN); Youth Olympic Games Ambassador Yelena Isinbaeva (RUS); Olympic fencer and IOC Athletes’ Commission Chair Claudia Bokel (GER); and IOC Olympic Games Executive Director Gilbert Felli (SUI).  14 OLYMPIC REVIEW  OLY040_P0014EDeng.indd 14  24/03/2014 16:30"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "VENEZUELAN NOC OPENS OLYMPIC STUDIES CENTRE  MORE THAN 60 COUNTRIES MARK WORLD TENNIS DAY  A “Pierre de Coubertin” Olympic studies centre has been inaugurated at the headquarters of the NOC of Venezuela, at a ceremony led by NOC President Eduardo Alvarez. Numerous sports leaders, athletes and personalities were also present. Created thanks to support from Olympic Solidarity and the Venezuelan Sports Ministry, this centre’s objective is to promote Olympism among the community and to be a permanent forum for discussion on issues related to the values of sport.  More than 60 of the International Tennis Federation’s (ITF’s) member national associations joined some of the world’s leading tennis stars in celebrating the second World Tennis Day on 3 March, aiming to promote tennis and increase participation among players around the globe. This year’s World Tennis Day was centred around three special events in Hong Kong, London and New York, which featured current and former professionals together with junior and wheelchair demonstrations, including the ITF’s Tennis Play and Stay campaign. Tomas Berdych, Lleyton Hewitt, Li Na and Samantha Stosur were in action at the Hong Kong Velodrome; Andre Agassi, Pete Sampras, Pat Cash and Ivan Lendl contested the World Tennis Day Showdown at London’s Earls Court; and Novak Djokovic, Andy Murray, Bob and Mike Bryan, and John and Patrick McEnroe took part at New York’s Madison Square Garden. Alongside these events, the ITF encouraged its national  2014 AIBA WOMEN’S WORLD BOXING CHAMPIONSHIPS TO BE HELD IN JEJU The International Boxing Association (AIBA) has announced that the 2014 AIBA Women’s World Boxing Championships will be organised in the city of Jeju, the Republic of Korea, from 13 to 25 November, in conjunction with the AIBA Congress. The competition will be held at the Halla Gymnasium of Jeju City, the largest city on the island of Jeju.  associations to support World Tennis Day with their own grassroots and club activities to attract new participants to the sport. These included the United States Tennis Association (USTA), which established the successful Tennis Night in which clubs were asked to open their doors as part of a drive to get children playing the sport. Argentina, meanwhile, shut down the widest road in the world, Avenida 9 de Julio in Buenos Aires, so that 500 children could play on 50 quickly constructed tennis courts. In Egypt, the ancient pyramids served as an iconic backdrop for tennis matches, while tennis demonstrations were also held in shopping centres throughout Brazil. “World Tennis Day proved to be a very successful initiative, using high-profile special events to bring attention to the developmental activities of our member nations on every continent,” said ITF President Francesco Ricci Bitti. “The enthusiasm and commitment of our National Associations to World Tennis Day was inspiring.”  Below Pete Sampras gives advice during a tennis clinic in London (top); Li Na signs autographs in Hong Kong (middle); Tomas Berdych greets fans in Hong Kong (bottom)  INAUGURAL ITTF STAR AWARDS HELD IN DUBAI China’s Zhang Jike and Li Xiaoxia have been crowned the first ever Male and Female Table Tennis Stars by the International Table Tennis Federation (ITTF). Organised in cooperation with the Dubai Sports Council, the inaugural 2013 ITTF Star Awards attracted the who’s who  of the table tennis world. Current Olympic champion Zhang Jike, who successfully defended his World Championship gold in 2013, said: “It is a very big honour to win this award.” The 2013 Female Table Tennis Star, Li Xiaoxia, who added the 2013 World Championship gold  to the Olympic gold she won in London in 2012, stated: “Thank you everyone for their support, especially Chinese table tennis. I am very honoured to win this prestigious award, especially as it is the first one in history. I will try my best in the future to bring more success.”  OLYMPIC REVIEW 15  OLY040_P0015EDeng.indd 15  21/03/2014 12:16"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "FIE ANNOUNCES DATES FOR NEW FENCING GRAND PRIX SERIES  WOA UNVEILS NEW BRAND IDENTITY  The International Fencing Federation (FIE) has announced the dates and host cities for the newly created FIE Fencing Grand Prix Series (FGP Series). The FGP Series comprises nine top-level events in nine cities around the world, spread from November to June, featuring the world’s best fencers. FIE Secretary General Frédéric Pietruszka commented: “The format of the FGP series will be TV and media-friendly as well  The World Olympians Association (WOA), the representative body for all Olympians worldwide, launched its new logo and website in an unveiling at the IOC Olympic Club during the Sochi 2014 Winter Games. The new brand and interactive website (www.olympians.org) symbolises the new direction of the WOA and showcases the work which has been done in the last two years to revitalise the international organisation for Olympians and give it a renewed sense of purpose. The WOA’s new online presence is a celebration of the work being carried out by Olympians and National Olympians Associations worldwide with the communities in which they live. The new website will also offer its Olympian members new ways to connect and communicate with each other and share experiences. Speaking about the event and the launch, Joël Bouzou, WOA President, said: “This is a very exciting time for the WOA and we’re delighted to launch our new identity and website here at  as attractive for spectators on site. We have to go new ways if we want to raise the popularity and visibility of fencing. “There are many great athletes and real stars among our fencers and we take it as our duty to provide them with an excellent framework to showcase their talent.” The FIE FGP will begin with foil events in Turin, Italy from 29 to 30 November 2014. Visit www.fie.org for a list of all the cities and dates.  HALIFAX TO HOST 2015 WORLD MEN’S CURLING CHAMPIONSHIP The World Curling Federation (WCF) has announced that Halifax, Nova Scotia, in Canada will host the World Men’s Curling Championship in 2015. The championship will take place between 28 March and 5 April 2015 at the 10,500-seat Halifax Metro Centre – the first time the world men’s  championship will have ever been played in the province. “We are delighted to be returning to the province of Nova Scotia for a World Curling Championship, the first since the World Junior Men’s Curling Championship was held in Dartmouth in 1986,” said World Curling Federation President Kate Caithness.  the Olympic Winter Games in Sochi. We believe the new logo and website signify the great strides we have made in 2012 and 2013 with the appointment of a new CEO, the creation and launch of our National Olympians Association Development Fund and Project Fund, and our much improved communications with our members around the world.” Below The interactive website symbolises the new direction of the WOA  WHO’S READING OLYMPIC REVIEW?  Who: Norwegian biathlete Tora Berger enjoys the latest issue of Olympic Review after collecting her silver medal for the women’s 10km pursuit event. She also won gold in the mixed relay. Where: The Sochi 2014 Olympic Winter Games  16 OLYMPIC REVIEW  OLY040_P0015EDeng.indd 16  21/03/2014 12:16"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0017EDeng.indd 1  24/03/2014 16:53"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  From Sochi With Love Olympic Review looks back on 17 days of thrilling Sochi 2014 action, as Russia hosted the Olympic Winter Games for the first time  18 OLYMPIC REVIEW  OLY040_P0018EDeng.indd 18  24/03/2014 15:12"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 1 The Sochi 2014 Olympic Winter Games burst into life with a sensational celebration of the best of Russian culture  In a fitting tribute to the “patchwork quilt” of modern Russia, which inspired the unique and colourful “look” of these Games, the Sochi 2014 Opening Ceremony took fans and viewers around the world on a spectacular journey through the country’s rich history and diverse cultural heritage. From the surrealism of a scene involving a floating St Basil’s Cathedral, to the grace and athleticism of a ballet performance depicting Tolstoy’s War and Peace, the breath-taking ceremony brought Sochi 2014 to life in sensational fashion. Once athletes from a record 87 National Olympic Committees had paraded into the stadium to enthusiastic cheers from the 40,000-strong crowd, they took their seats to enjoy a wide-ranging and unforgettable show, which drew inspiration from the best of Russian music, ballet, literature and architecture, while also celebrating significant eras and figures from the country’s past. Tchaikovsky’s renowned Swan Lake was given a new twist, with dancers glowing and swirling across the vast stage of the Fisht Olympic Stadium, while the Russian Revolution was marked with a dramatic scene involving giant tractors, machine cogs, oversized tools and a flying locomotive, all accompanied by a loud, pounding soundtrack signifying the turmoil and massive change of the time. Once Russian president Vladimir Putin had officially declared the Games open, a stirring sequence involving huge, illuminated sporting “constellations” heralded the arrival of the Olympic torch into the stadium, with Russian sports stars Maria Sharapova, Yelena Isinbaeva, Alexandr Karelin and Alina Kabaeva each taking their turn to carry the Olympic flame. The climax of the Ceremony then saw Russian Olympic legends Vladislav Tretiak and Irina Rodnina light a cauldron at the heart of the Olympic Park, while fireworks illuminated the Sochi skyline and fans wondered what other inspirational spectacles they could look forward to witnessing in the following 16 days.  OLY040_P0019EDeng.indd 19  24/03/2014 15:17"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 2 Athletes write their names into the history books as new events make their Winter Games debuts and Olympic records fall Following on from the spectacular leaps and pirouettes seen in the Opening Ceremony’s ballet performances, it seemed fitting that the first medals of Sochi 2014 were awarded in a similarly acrobatic event. Snowboard slopestyle, making its debut at the Olympic Winter Games, had immediately enthralled fans with its thrilling combination of mind-boggling tricks and gravity-defying big airs, and writing his name into the history books as the first ever Olympic gold medallist in this new event was the USA’s Sage Kotsenburg – a 20-year-old from Park City, Utah, who had been inspired by watching snowboarding at the 2002 Olympic Winter Games in Salt Lake City. Kotsenburg wowed the judges in his first run of the final, scoring 93.50 points thanks  OLY040_P0018EDeng.indd 20  to an awe-inspiring array of tricks that included the first ever backside 1620 Japan air (which involves rotating four and a half times during the jump, while grabbing the heel edge of the board with the front hand) to be landed in competition. \"I’m really excited. It feels awesome,” he said afterwards. “This is the craziest thing that’s ever happened.” Elsewhere, other athletes were also etching their names into the Olympic history books, with Dutch speed skater Sven Kramer breaking his own Olympic record while successfully defending his 5,000m title in the Adler Arena, and Norwegian biathlete Ole Einar Bjørndalen winning gold in the 10km sprint to equal compatriot Bjørn Dæhlie’s record tally of 12 Olympic Winter Games medals.  21/03/2014 13:12"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 3 The host nation celebrates its first medals of the Games, while the sound of cowbells echoes around the Caucasus Mountains as the Alpine skiing events begin  The Russian fans filling Sochi’s venues were given plenty of reasons to cheer on the third day of the Games, as the country’s athletes secured their first medals of the Games. First, speed skater Olga Graf won bronze in the women’s 3,000m behind silver medallist Martina Sáblíková, from the Czech Republic, and new Olympic champion Ireen Wüst from the Netherlands. Then Olga Vilukhina secured silver in the women’s biathlon sprint, which was won by Slovakia’s Anastasiya Kuzmina. Russia then celebrated its first gold of the Games, with rousing performances from 15-year-old Yulia Lipnitskaya and national icon Evgeny Plushenko helping to ensure Russia topped the podium in the new team figure skating event. Lipnitskaya received a standing ovation at the Iceberg Skating Palace after scoring 141.51 in her spectacular free skate to secure the top spot, while Plushenko and  the pairing of Ksenia Stolbova and Fedor Klimov also won their free programmes, with ice dancers Elena Ilinykh and Nikita Katsalapov finishing third. Finally, Albert Demchenko – competing in his seventh Games – secured silver in the men’s luge behind Germany’s Felix Loch, with Italy’s Armin Zöggeler winning bronze to become the first athlete to claim six medals at six different Winter Games. Elsewhere, the familiar sound of cowbells was ringing through the Caucasus Mountains, as the Alpine skiing events got underway at the Rosa Khutor Alpine Centre. And it was the Austrian fans who were ringing their bells the loudest, with Matthias Mayer winning gold in the men’s downhill ahead of Italy’s Christof Innerhofer and Kjetil Jansrud of Norway, as well as much-heralded rivals such as World Cup leader Aksel Lund Svindal and five-time Olympic medallist Bode Miller.  OLYMPIC REVIEW 21  OLY040_P0021EDeng.indd 21  24/03/2014 15:22"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 4 Siblings take centre stage in Sochi on day 4 of the Games as twins share the podium and a freestyle skier takes inspiration from his brother Olympic fans could have been forgiven for thinking they were seeing double as Dutch speed skating twins Michel and Ronald Mulder took to the ice of the Adler Arena on day 4 of the Games. The 27-year-olds became just the second set of twins to win an Olympic medal in the same individual event at the same Winter Games, as Michel won gold and Ronald secured bronze in the men’s 500m. Compatriot Jan Smeekens won silver to complete the Netherlands’ second clean sweep of the speed skating podium in three days. At the Rosa Khutor Extreme Park, meanwhile, Canada’s Alex Bilodeau was also taking inspiration from his brother to successfully defend his men’s moguls title. The 26-year-old – whose brother  suffers from cerebral palsy – became the first freestyle skier to successfully defend an Olympic title, as he recovered from a ragged first run to post a score of 26.31 in the final round, thanks to highly difficult back double full and off-axis 1080 jumps. Elsewhere, French biathlete Martin Fourcade overcame his rivals – including brother Simon – to win the men’s 12.5km pursuit. The 25-year-old, who previously won silver in the mass start event in Vancouver in 2010, was pleased to share his gold medal experience with his older sibling, who finished 18th. “Being an Olympian is something wonderful, but sharing it with him is something incredible,” he said afterwards.  22 OLYMPIC REVIEW  OLY040_P0022EDeng.indd 22  24/03/2014 15:20"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 5 History is made as women’s ski jumping leaps on to the Olympic programme, while female athletes also star in luge and freestyle skiing Germany’s Carina Vogt leapt her way into Olympic history on day 5 of the Games as she became the first-ever Olympic champion in women’s ski jumping. A packed crowd, armed with an array of horns, bells and flags, ensured an electric atmosphere greeted the athletes when they stepped on to the normal hill at the RusSki Jumping Centre to become the first female ski jumpers ever to compete in an Olympic Winter Games. Despite leading at the halfway stage thanks to a first-round jump of 103m, Vogt faced a stern gold-medal challenge from the likes of 2011 world champion Daniela Iraschko-Stolz of Austria, France’s two-time World Cup winner Coline Mattell, and 2012 Winter Youth Olympic Games gold medallist Sara Takanashi of Japan. A wind-assisted jump of 104.5m saw Iraschko-Stolz take the lead in the second round and, with both Mattell and Takanashi failing to surpass the Austrian’s total score, it left Vogt to chase gold with the last jump of the evening. While the 22-year-old’s 97.5m effort was shorter than Iraschko-Stolz’s, superior style marks and wind compensation points ensured her an historic victory by 1.2 points. “I cannot find the right words, it’s amazing,” she said afterwards. “I’m the first woman champion in ski jumping!” Elsewhere, Vogt’s compatriot Natalie Geisenberger was also etching her name into the record books by claiming gold in the women’s luge with the biggest winning margin in any luge event at the Winter Games since 1964, while Canada’s Dara Howell won the inaugural women’s ski slopestyle event with a highly technical run that scored a massive 94.20 points.  OLYMPIC REVIEW 23  OLY040_P0022EDeng.indd 23  24/03/2014 15:20"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 6 An unprecedented tie sees two athletes win Alpine skiing gold, while more drama is witnessed in the women’s snowboard halfpipe In brilliant sunshine at the Rosa Khutor Alpine Centre, the women’s downhill produced perhaps the most dramatic result in Olympic skiing history. In the 134 previous Alpine skiing finals, spanning 78 years, there had never been a tie for first place. But that all changed on the sixth day of the Sochi 2014 Winter Games, with Slovenia’s Tina Maze and Switzerland’s Dominique Gisin both clocking one minute 41.57 seconds to finish in an extraordinary dead heat. Gisin, starting as the eighth racer, looked to have done enough to secure gold as challengers such as Vancouver 2010 silver medallist Julia Mancuso, super combined champion Maria Høfl-Riesch and Vancouver 2010 bronze medallist Elisabeth Gørgl all failed to go faster over the 2.7km course. But Maze – starting in bib 21 – burst out of the starting gates, recording faster splits than Gisin at every interval before losing a little speed after the final jump to finish in exactly the same time as the 28-year-old Swiss. The remarkable result meant that for the first time in Olympic history, two gold medals were awarded in an Alpine skiing event, with both Maze and Gisin stepping on to the top of the podium, while Switzerland’s Lara Gut won bronze. There was more drama at the women’s snowboard halfpipe event, as Australia’s defending champion Torah Bright and the USA’s 2002 gold medallist Kelly Clark left it until the last two runs of the competition to secure silver and bronze respectively, with American Kaitlyn Farrington winning gold thanks to a score of 91.75.  24 OLYMPIC REVIEW  OLY040_P0024EDeng.indd 24  24/03/2014 15:49"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 7 Germany proves its dominance on the luge track, while the USA’s freestyle skiers demonstrate their slopestyle prowess  With enthusiastic fans finding every possible vantage point along the 1.3km track at the Sanki Sliding Centre, Germany’s Natalie Geisenberger, Felix Loch, Tobias Wendl and Tobias Arlt stormed their way to gold in the first ever luge team relay event at the Olympic Winter Games. The historic victory completed a clean sweep of the Sochi 2014 luge titles for Germany, with Geisenberger previously winning the women’s gold, Loch crowned men’s champion for the second successive Games, and Wendl and Arlt combining to win the doubles event. After Latvia had set the early pace, clocking 2:47.295 for their combined runs, the Russian team of Tatyana Ivanova, men’s singles silver medallist Albert Demchenko, Alexander Denisyev and Vladislav Antonov sent the Sanki crowd wild as they completed the course in 2:46.679 to take the gold medal position.  But Germany’s 'dream team’ would not be denied their second gold medals of the Games, as they came home over a second faster than their Russian rivals. “We normally are individual athletes but now to become Olympic champion as a team, this is the greatest,” said Geisenberger afterwards. Higher up the Caucasus Mountains, France’s Martin Fourcade was also winning his second gold medal of the Games as he claimed the 20km individual biathlon title to become the first French athlete to win two gold medals at a Winter Games since Jean-Claude Killy’s Alpine skiing hat-trick in 1968. The USA’s freestyle skiers, meanwhile, were celebrating a hat-trick of their own as they swept the podium in the men’s ski slopestyle, with Joss Christensen claiming gold ahead of Gus Kenworthy (silver) and Nick Goepper (bronze).  OLYMPIC REVIEW 25  OLY040_P0025EDeng.indd 25  24/03/2014 15:55"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 8 Japan crowns a new figure skating hero, while Belarus enjoys a golden day and Britain secures a second successive skeleton title Yuzuru Hanyu glided off with the men’s figure skating gold medal on day 8 of the Games, becoming the first Japanese man to win the Olympic title, while also securing Japan’s first gold of Sochi 2014. Following his world record short programme score of 101.45 the previous evening, the 19-year-old landed a quadruple toe-loop and seven triples as he received a total of 280.09 points to beat Canada’s three-time world champion Patrick Chan. Kazakhstan’s Denis Ten surged from ninth place after the short programme to win bronze. It also proved to be a golden day for Belarus, with Darya Domracheva winning her second gold medal of the Games in the women’s 15km biathlon event and 34-year-old veteran Alla Tsuper claiming the women’s freestyle skiing aerials ahead of China’s Xu Mengtao and defending champion Lydia Lassila of Australia. At the Sanki Sliding Centre, meanwhile, Lizzy Yarnold won the women’s skeleton to secure Great Britain’s first gold medal of the Games, with the USA’s Noelle Pikus-Pace finishing second and Russia’s Elena Nikitina claiming bronze – much to the delight of the enthusiastic local crowd.  26 OLYMPIC REVIEW  OLY040_P0026EDeng.indd 26  24/03/2014 15:33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 9 A stunning finish provides thrills at the cross-country skiing, while Russian fans celebrate short track and skeleton golds In one of the most exciting finishes seen at these Games, Charlotte Kalla overtook Krista Lahteeenmaki, of Finland, and Germany’s Denise Herrmann to win the women’s 4x5km cross-country relay for Sweden and secure her third medal of Sochi 2014. The 26-year-old – who had previously claimed silver in both the skiathlon and 10km classic event – began the final leg of the relay in third place, 25.7 seconds behind her rivals.  With Lahteeenmaki and Herrmann jostling for the lead as the race entered its final stages, Kalla stormed along the home straight to secure a thrilling victory in dazzling sunshine, prompting wild celebrations from team-mates Ida Ingemarsdotter, Emma Wiken and Anna Haag. There were raucous celebrations at the Iceberg Skating Palace too, where Victor An secured Russia’s first ever Olympic gold medal in short track speed skating, following his victory in the men’s 1,000m ahead of  compatriot Vladimir Grigorev and Sjinkie Knegt of the Netherlands. And there was more joy for Russia in the men’s skeleton, with reigning world champion Alexander Tretiakov claiming gold at the Sanki Sliding Centre, while Polish fans were revelling in the victories of speed skater Zbigniew Brodka, in the men’s 1,500m, and ski jumper Kamil Stoch, who added the large hill title to the normal hill crown he won earlier in the Games.  OLYMPIC REVIEW 27  OLY040_P0026EDeng.indd 27  24/03/2014 15:33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 10 Norway’s Kjetil Jansrud finally gets his hands on an Olympic gold medal, while the Netherlands sweep the speed skating podium once again  After winning silver in the giant slalom in Vancouver four years ago, and bronze in the downhill earlier in the Sochi Games, Norway’s Kjetil Jansrud finally felt the joy of becoming an Olympic champion, as he secured gold in the men’s super-G at a sun-drenched Rosa Khutor Alpine Centre. “It’s an honour to be at the top of the podium in an Olympic competition,” said the 28-year-old. “It’s a little bit of a cliché, but it’s something you dream about since you’re a kid. I’m one of those kids. Being here is an amazing feeling.\" The USA’s Andrew Weibrecht claimed silver, with compatriot Bode Miller and Canada’s Jan Hudec sharing bronze, making Miller, at 36, the oldest ever  Olympic medallist in Alpine skiing. In the Adler Arena, Jorien ter Mors led home a Dutch clean sweep of the medals in the women’s 1,500m speed skating event, setting a new Olympic record of one minute 53.51 seconds in the process. Lotte van Beek beat team-mate Marrit Leenstra to the silver medal. Elsewhere, Czech Republic’s Eva Samkova put on a masterclass to win the women’s snowboard cross title ahead of Dominique Maltais of Canada and Chloe Trespeuch of France, while the Swedish quartet of Marcus Hellner, Lars Nelson, Johan Olsson and Daniel Richardson led from start to finish to win gold in the men’s cross-country 4x10km relay.  28 OLYMPIC REVIEW  OLY040_P0028EDeng.indd 28  24/03/2014 15:38"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 11 Alexander Zubkov and Alexey Vovoeda win an historic bobsleigh gold medal for the hosts, while Belarus also enjoys a golden day thanks to Darya Domracheva and Anton Kushnir Alexander Zubkov and Alexey Vovoeda made history at the Sanki Sliding Centre, as they handed Russia its first-ever Olympic gold medal in bobsleigh by winning the two-man event. The duo recorded a combined time of three minutes 45.39 seconds over the four runs to finish 0.66 seconds ahead of Switzerland, who took silver, and 0.88s ahead of the USA, who finished third. Darya Domracheva also struck gold as she won the women’s 12.5km mass start event to secure her third Olympic title of the Sochi 2014 Winter Games. The Belarusian biathlete, who had previously won the 15km  individual event and the 10km pursuit, dominated the race from start to finish, building a 10-second lead by the second lap and missing just a single shot in the final shooting round. Domracheva’s compatriot Anton Kushnir later won another gold medal for Belarus as he claimed the men’s freestyle skiing aerials title ahead of Australia’s David Morris and China’s Jia Zongyang, while US figure skaters Meryl Davis and Charlie White became the first Americans to win the Olympic ice dance title as they beat defending champions Tessa Virtue and Scott Moir of Canada by 195.52 points to 190.99.  Day 12 The Republic of Korea’s women make up for Vancouver 2010 heartbreak with short track relay gold A thrilling last-lap manoeuvre by Shim Sukhee secured gold for the Republic of Korea in the women’s 3,000m short track relay, with runners-up China disqualified for impeding. The Korean quartet made up for the disappointment of their own disqualification in the Vancouver 2010 final to secure their fifth relay victory in the last six Winter Games, with Canada claiming silver and Italy bronze. Norway’s Jørgen Graabak also made up for his earlier disappointment by clinching gold in the Nordic combined large hill/10km event, having previously missed out on  selection for the normal hill/10km, while a thrilling finish in the men’s 15km biathlon mass start event saw Norway’s Emil Hegle Svendsen beat Martin Fourcade of France in a photo finish to clinch gold. Elsewhere, Slovenia’s Tina Maze won her second gold medal of the Games with victory in the women’s giant slalom, while the USA’s David Wise became the first Olympic champion in the men’s ski halfpipe and speed skater Jorrit Bergsma set a new Olympic record in the 10,000m as he led home a Dutch clean sweep.  OLYMPIC REVIEW 29  OLY040_P0029EDeng.indd 29  24/03/2014 16:45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Ole Einar Bjørndalen (pictured second from right) became the most decorated athlete in Winter Games history as he secured a record 13th Olympic medal in an event that was being held for the first time. The 40-year-old Norwegian, competing in his sixth Games, teamed up with compatriots Emil Hegle Svendsen, Tora Berger and Tiril Eckhoff to win the inaugural mixed biathlon relay, giving  him his eighth Olympic gold medal and 13th overall, eclipsing the record of cross-country skier Bjørn Dæhlie. In the women’s bobsleigh, a dramatic late surge saw Canadian duo Kaillie Humphries and Heather Moyse successfully defend their Olympic title as they edged the USA’s Elena Meyers and Lauryn Williams by just 0.10 seconds, having trailed by 0.11 seconds  heading into the final run. In the women’s cross-country team sprint, Norway’s Marit Bjørgen secured the fifth Olympic gold of her career with a ninesecond victory over Finland alongside partner Ingvild Flugstad Oestberg, while the USA’s Ted Ligety claimed a similarly comprehensive win in the men’s giant slalom, beating France’s Steve Missillier by 0.48 seconds.  Day 13 The Games crowns its most successful Winter Olympian ever, while Canada’s women defend their bobsleigh title  30 OLYMPIC REVIEW  OLY040_P0030EDeng.indd 30  24/03/2014 15:39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 14 Canada celebrate women’s curling gold for the first time in 16 years, while the country’s women secure a dramatic victory in the ice hockey final After 16 years of waiting, Canada’s women finally won their second Olympic curling title, with Jennifer Jones’ team beating two-time defending champions Sweden to finish the tournament unbeaten. The 6-3 victory in front of a packed crowd at the Ice Cube Curling Centre was Canada’s first women’s curling gold since 1998, when the sport returned to the Olympic programme in Nagano. Earlier, Great Britain secured bronze, with Eve Muirhead’s team beating Switzerland 6-5 in the third-place play-off. The women’s ice hockey final saw Canada celebrating gold once again, although the victory was far less assured than Jones’ curling exploits. With the USA leading 2-1 heading into the final minute, Marie-Philip Poulin scored to force overtime before striking again in the extra period to give Canada its fourth successive Olympic gold. A similarly thrilling night at the Iceberg Skating Palace saw Adelina Sotnikova become the first Russian to win Olympic gold in women’s figure skating, with a superb free programme giving the 17-year-old a narrow victory over the Republic of Korea’s defending champion Yuna Kim. The result led to raucous celebrations in the Sochi venue.  OLYMPIC REVIEW 31  OLY040_P0030EDeng.indd 31  24/03/2014 15:39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 15 Ukraine secure an emotional gold in the women’s biathlon relay, while Victor An becomes the most successful short track skater in Olympic history High on the Psekhako Ridge above Krasnaya Polyana, Juliya Dzhyma, Olena Pidhrushna and twins Vita and Valj Semerenko claimed an historic gold medal for Ukraine, as they combined to win the women’s biathlon relay. The quartet – who each hold an Olympic Solidarity Scholarship – beat defending champions Russia by more than 26 seconds to give Ukraine only its secondever gold medal in the Winter Games, in what IOC President Thomas Bach described as a “really emotional moment”.  Elsewhere, the decibel level at the Iceberg Skating Palace reached new heights as Russia’s Victor An became the most successful short track speed skater in Olympic history by winning gold in both the men’s 500m and 5,000m relay. The victories took An’s career total to six golds and two bronzes, but the 28-year-old had to dig deep on the final lap to win the 500m title, while he also made the decisive move in the relay to send the partisan crowd into a frenzy.  32 OLYMPIC REVIEW  OLY040_P0032EDeng.indd 32  24/03/2014 15:40"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 16 The first Olympic medals in snowboard parallel slalom are awarded, while Marit Bjørgen becomes the most decorated female winter Olympian ever  Snowboard parallel slalom enjoyed a dramatic entry to the Winter Games on the penultimate day of Sochi 2014, as Austria’s Julia Dujmovits made a thrilling recovery to become the event’s first Olympic champion. The 26-year-old was trailing Germany’s Anke Karstens by a seemingly unbridgeable 0.72 seconds after the first run, but a remarkable comeback saw her secure gold by just 0.12 seconds after the second and final run of the 325m course. In the men’s event, Russia’s Vic Wild overturned a similar deficit in his semi-final against Benjamin Karl of Austria before beating Slovenia’s Zan Kosir in the final to  win his second gold of the Games, following his earlier victory in the giant slalom. Norway’s Marit Bjørgen, meanwhile, was picking up her third gold medal of the Games – and the sixth of her career – as she won the women’s cross-country 30km mass start to become the most decorated female in Winter Games history. It was the 33-year-old’s 10th Olympic medal and saw her match the six golds won by Russian cross-country skier Lyubov Egorova and former Soviet speed skater Lidia Skoblikova. “I’m not thinking about how many gold medals I have,” said Bjørgen afterwards. “I just really wanted the 30km gold medal and I’m really happy.”  OLYMPIC REVIEW 33  OLY040_P0032EDeng.indd 33  24/03/2014 15:40"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  34 OLYMPIC REVIEW  OLY040_P0018EDeng.indd 34  21/03/2014 13:14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Day 17 Canada successfully defend the men’s ice hockey title, as the curtain falls on Sochi 2014 with another dazzling celebration of Russian culture in the Closing Ceremony  While Russian fans had been hoping their men’s ice hockey team could emulate Canada’s Vancouver 2010 exploits by winning gold on home soil, their quarter-final exit left Sweden battling the defending champions for the Olympic title in Sochi 2014’s final event. A strong Canadian following inside the Bolshoi Ice Dome was eager to see its heroes win back-to-back gold medals for the first time in more than 50 years, and goals from Jonathan Toews, Sidney Crosby and Chris Kunitz ensured they would leave Sochi with smiles on their faces. Russian fans also had reason to cheer, however, with Alexander Legkov leading home a clean sweep in the men’s 50km cross-country race before the hosts secured their 13th gold medal of the Games in the four-man bobsleigh. With spirits on a high, fans filed into the Fisht Olympic Stadium for the Closing Ceremony, as the curtain came down on Sochi 2014 with a dazzling celebration of Russian culture, featuring tributes to literary giants such as Pushkin, Tolstoy, Dostoevsky and Chekhov, as well as scenes hailing Russian artists and the world-famous Bolshoi and Mariinsky Theatres. Once the Olympic flag had been handed to PyeongChang and the Olympic flame had been poignantly “blown” out by Sochi’s polar bear mascot, 3,000 children holding mimosa branches transformed the stadium into a blooming meadow to mark the end of the Russian winter, and the end of Russia’s first Olympic Winter Games.  OLYMPIC REVIEW 35  OLY040_P0035EDeng.indd 35  24/03/2014 15:41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Behind the Lens Five IOC photographers each share the story behind their chosen iconic image taken at the Olympic Winter Games in Sochi  36 OLYMPIC REVIEW  OLY040_P0036EDeng.indd 36  21/03/2014 13:23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0036EDeng.indd 37  21/03/2014 13:23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "38 OLYMPIC REVIEW  OLY040_P0036EDeng.indd 38  21/03/2014 13:23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Skeleton Men’s Skeleton 15 February Sanki Sliding Centre  “I think the skeleton start is very aesthetic and I wanted to capture that. I also really like the reflection on the helmet, almost like showing what is on the athlete’s mind. If you look closely, you can see his coach cheering him on in the background. This photo is also topped with one of my favourite things: ice freckles caught in the air.” Mine Kasapoglu  OLYMPIC REVIEW 39  OLY040_P0036EDeng.indd 39  21/03/2014 13:23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Figure Skating Team Pairs Short Programme 6 February Iceberg Skating Palace  “Figure skating combines intense athleticism with incredible artistry and it is that combination that I look to capture. But it is difficult to photograph as skaters never move in a straight line! Another interesting thing is that it is one of the only sports in which a team uniform is not worn which makes for beautiful colour combinations on the ice.” John Huet  40 OLYMPIC REVIEW  OLY040_P0036EDeng.indd 40  21/03/2014 13:23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC REVIEW 41  OLY040_P0036EDeng.indd 41  21/03/2014 13:23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Freestyle Skiing Women’s Moguls 8 February Rosa Khutor Extreme Park “The athletic height moments at the Games are obvious and abundant. One of the things I try to capture are the quieter moments of intensity and concentration required for the few seconds of the actual competition. This image of Justine Dufour-Lapointe is just before her preliminary moguls run the night she won a gold medal. Hearing her coach and watching this was a special moment, and the fact that the picture also resonates with Justine makes it important to me.” Jason Evans  42 OLYMPIC REVIEW  OLY040_P0042EDeng.indd 42  24/03/2014 15:02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC REVIEW 43  OLY040_P0036EDeng.indd 43  21/03/2014 13:24"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Luge Men’s Doubles 12 February Sanki Sliding Centre “This photo from the men’s luge doubles is one of my favourites from the Games. I didn’t have a lot of time to really search for my photo position as I was coming from another event. I was happy to not only capture the luge team and the Olympic rings and the track, but also to have it all framed by the beautiful sunset on the mountains in the background – I only got a few images before the sun went down.” Christopher Graythen  44 OLYMPIC REVIEW  OLY040_P0036EDeng.indd 44  21/03/2014 13:24"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC REVIEW 45  OLY040_P0036EDeng.indd 45  21/03/2014 13:24"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Biathlon Men’s 15km mass start 18 February Laura Cross-country Ski & Biathlon Centre “I wanted to catch the large flight of skiers, and went to the first turn in the course, where they begin to climb the hill. It’s quite something to see them come towards you like that, passing by so close that you feel the rush of the wind as they go by. I shot with a ‘normal’ lens as the distance was quite close to begin with. The ‘mass start’ is always something to see, and this was no disappointment.” David Burnett  46 OLYMPIC REVIEW  OLY040_P0046EDeng.indd 46  24/03/2014 15:03"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0036EDeng.indd 47  21/03/2014 13:24"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Image makers  Mine Kasapoglu  John Huet  What was the highlight of your Olympic Games in Sochi? The Games in Sochi were great. The weather was warm, the venues were cool, and the Russians are super-friendly and helpful. The sunrise and the sunset in the Olympic Park were unforgettable.  What was the highlight of your Olympic Games in Sochi? This may sound corny but the highlight for me has been the Sochi volunteers. They have been unbelievably helpful and I would not have been able to do my job without their assistance. From a photographic perspective, a highlight was the women’s ski jumping event; it was one of those magical nights where both the light and the atmosphere are just right.  What makes an iconic Olympic photo? A photograph that captures an athlete truly in the moment. The image should also be judged on the following criteria: composition, story, action, surprise, timelessness and good light. These points will be multiplied by the technical diffi culty and the artistic expression of the photo. Those with the highest scores can be considered iconic Olympic photographs. Which Olympian would you have liked to photograph? Hermann Maier in Nagano 1998.  Which Olympian would you have liked to photograph? There are many! I would have loved to have photographed Jesse Owens, or Dick Fosbury doing his famous “Fosbury flop”. I did high jump at school and had an unrealistic goal of competing in the Olympic Games in Moscow in 1980. I really had no chance to get there and the Games were actually boycotted by the USA, but that was my dream.  Jason Evans  Christopher Graythen  David Burnett  What was the highlight of your Olympic Games in Sochi? In Vancouver I was determined to get a game-used hockey puck. Unfortunately, I never did. In Sochi, I realised what a rare occurrence it was and dismissed the idea. During my first game, a puck came under the net and landed at my feet. It was a highlight because in the end, we are all really just fans of the game.  What was the highlight of your Olympic Games in Sochi? Covering the USA vs Russia hockey match was one of the highlights. Just walking into the building you could really feel the intensity of the players and the crowd, and to witness a thrilling finish was very special.  What was the highlight of Sochi 2014 for you? Standing with the Nordic combined ski jumpers at the top of the large hill ski jump, just centimetres from the grooves that they fit their skis into to slide into the sky. There are few times where people’s bodies make a ‘whoosh’ sound.  What makes an iconic Olympic photo? For me, iconic Olympic photos capture the total emotion of the moment for the athletes. Sometimes that’s the pure joy of winning, and sometimes it’s the agony of defeat. You have to find that moment of raw emotion when it all comes together.  Which Olympian would you have liked to photograph? I grew up across the street from Alf Engen, a Norwegian immigrant who came to the USA in the 1930s, and brought with him a whole new sense of what Alpine skiing was about. He made the US team in 1940 as both a slalom skier and a ski jumper but those Games were cancelled because of war, and he never got to compete. I would love to have accompanied him to the top of a ski jump and watched him perform that fearless gesture on skis. It would have been jumping with heart, and that heart is what I would have loved to capture.  Photographers are privy to the best of the action at an Olympic Games; we ask our five to share their experiences  What makes an iconic Olympic photo? It has to capture a significant event or emotion that you may not have the perspective on yet. Time weeds out which photo becomes iconic. Which Olympian would you have liked to photograph? When I was growing up Carl Lewis was an icon to me. He had the showmanship and the personality, as well as a great smile, which would have been great to capture.  Which Olympian would you have liked to photograph? If I had to choose a Winter Games athlete, I would love to have been at Eric Heiden’s five-gold-medal-performance at the 1980 Olympics. Speed skating is an amazing sport to shoot, along with that gold suit!  48 OLYMPIC REVIEW  OLY040_P0048EDeng.indd 48  24/03/2014 15:06"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0049EDeng.indd 1  24/03/2014 16:56"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Hot. Cool...“Ours” Athletes, fans, volunteers and officials relive their Sochi 2014 experiences 50 OLYMPIC REVIEW  OLY040_P0050EDeng.indd 50  21/03/2014 14:26"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Thomas Bach IOC President “These were great Olympic Winter Games. The response we got from all the different participants has been really overwhelmingly positive. I had the opportunity to spend four nights in the different Olympic Villages, speaking to the athletes, and there was not a single complaint. They really loved the facilities, the quality of the Olympic Villages, and the proximity of the Villages and their venues. These Games were a very special experience.”  Dmitry Chernyshenko Sochi 2014 President “At the beginning some people asked me, ‘What do you expect the most?’, and that was that the atmosphere we achieved would be the major outcome of the Games. This great atmosphere – in the Park it was electric. We have seen how dramatically the Games have changed my home city. This was a once-ina-lifetime opportunity not only for me and this particular city or entire region, but a unique chance for the country to show itself to the world. I hardly could have expected at the beginning of the journey that it would be as successful as it is now.”  OLYMPIC REVIEW 51  OLY040_P0050EDeng.indd 51  21/03/2014 14:26"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Teemu Selänne Ice hockey, Finland “Every Olympic Games is a new story and a new adventure. I’m very happy and thankful to be here. It doesn’t matter if it’s the first or sixth time, it’s very special and another great experience. Knowing it’s going to be my last Games is a good thing, as you can really enjoy it. You see things differently and just enjoy it.”  Sara Takanashi Ski jumping, Japan  Olga Posokhova Olympic fan from Russia  “All of Russia was so happy when Sochi won the Games and it’s great to see so many people here; it’s like a festival. We’re really enjoying it and I think all of Russia will remember these good times.”  “It’s my first time at the Olympic Games and I’m really happy that women are now able to participate in women's ski jumping. I’ve been living in the Olympic Village and it’s really fun. We eat all together and the food is really good. It’s a great experience being at the Olympic Games and I’m glad to be part of it. I came here wanting to do my best. I hope I will have a chance to compete in the next Olympic Games.”  52 OLYMPIC REVIEW  OLY040_P0050EDeng.indd 52  21/03/2014 14:26"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Conor Lyne  Bob de Jong  Alpine skiing, Ireland  Speed skating, Netherlands  “I like the general, day-to-day things like trading pins with athletes from other countries. It’s so simple, but you get to hear their story and share your own. You get to meet people who you don’t usually get to meet. And you get to meet people from different sports, like bobsleigh.”  “It’s great to be here. The atmosphere is great. The Village, the rooms, everything is perfect. And it is all very Russian. I like that. I like to experience the local culture, even if I only stay in the Olympic Village.”  Billy Demong (@BillyDemong), nordic combined, USA, on Twitter “Not sure about much but darn sure the weather, the people, the organisation and the scenery are amazing.”  Gracie Gold, Figure skating, USA “The novelty of the Olympic Games is it can be a once-in-alifetime competition. You can’t guarantee you will go to another one, no matter how good you are. So to be in your first one and experience everything for the first time is incredible. It’s like 100 out of 10. It’s unbelievable seeing all the countries, all the athletes. It was incredible to skate over the Olympic rings. I actually start my programme right in the centre.”  Sander van Ginkel Olympic fan from the Netherlands  “We’ve been here for five days and we’ve seen ski jumping, ice hockey and speed skating. The atmosphere is really nice, everyone seems friendly and I really like it. We were in London for the Games in 2012 as well and it feels very similar to that, especially with this nice weather!”  OLYMPIC REVIEW 53  OLY040_P0050EDeng.indd 53  21/03/2014 14:26"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0054EDeng.indd 1  24/03/2014 16:54"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Kevin Rolland Ski halfpipe bronze medallist, France  “I’ve taken part in all kinds of events and I was waiting for a long time for the chance to compete at the Olympic Games. I’ve really enjoyed watching my friends winning medals, such as Alexis Pinturault and Steve Missillier in the giant slalom. It’s awesome to be one of the first medallists in ski halfpipe because now I’m in the history books for life! Winning a medal was the goal and I’m stoked to have done that. The medal ceremony was crazy. You feel the energy from the crowd. It was a really good moment.”  Park Seung-Hee (@hkjhy0328) Short track gold medallist, (KOR) on Twitter  “Before our medal ceremony! This is a really happy day. We are being rewarded for all our efforts :-). Today we’ll just enjoy ourselves! Girls, we’ve come through a lot! ”  Colin Howieson Olympic fan from Canada “We went to Vancouver in 2010 and while we were there I decided to start saving to come to Sochi, as it was such a good experience. It’s nice to come to a country that you might not otherwise visit for such a great event. I convinced my parents to come as well and it’s been unbelievable so far. The venues and the events we’ve seen have been amazing. Everyone’s been so friendly and we’ve already been asked to pose for photos with Russian fans so many times. We’re having a great time and we’ve just been talking about maybe going to PyeongChang in four years’ time!”  OLYMPIC REVIEW 55  OLY040_P0055EDeng.indd 55  21/03/2014 14:27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Linda van Aalten Sochi 2014 volunteer from the Netherlands “I’d only seen the Games on TV, so I thought it would be a great experience to be part of the biggest event in the world. It’s beyond all my expectations and even bigger than I imagined. It’s great to be here and although we work hard, we’ve been able to see a lot of the Games as well, which is the icing on the cake. I got to go to the Opening Ceremony and that was amazing. The show was spectacular and that was when I realised that the Games were really starting and it was real. It was a great moment. It’s also been wonderful to meet people who have travelled here from all over the world and to learn more about Russia, plus the atmosphere around the Olympic Park has been really fantastic. It’s great when they thank the volunteers at each event. You feel so privileged to be here. It’s really a unique experience and opportunity.”  Ilya Nagorny Olympic fan from Russia  “I think this is showing the best of Russia. It’s cool to have the Olympic Games back here for the first time since 1980. There’s a very friendly atmosphere – it’s really nice – and I think this Olympic Park is brilliant for the local region.”  Chloé Dufour-Lapointe Moguls silver medallist, Canada  “In Vancouver I didn’t have my sisters with me, so I was kind of alone. It was my first experience of the Games, so I didn’t really know where I was going. Here it has been a whole new experience. We didn’t know what to expect, but now we have our medals and we’re just cherishing every moment.”  56 OLYMPIC REVIEW  OLY040_P0055EDeng.indd 56  21/03/2014 14:27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Miriam Kastlunger Luge, Austria  “The Games have been an amazing experience. All the media and the fans – it’s much bigger than at a World Cup event and I’ve only had good feelings while I’ve been here. I was at the Winter Youth Olympic Games in Innsbruck and I think that was a good experience to prepare me for this.”  Sage Kotsenburg Snowboard slopestyle gold medallist, USA “The atmosphere is unreal. When you come down to the bottom of the run and you see the Olympic rings and the crowd there, it’s unlike any other contest I’ve ever done. The Village is cool too. You meet so many people that you would never meet aside from here. I even met one of the guys from the Jamaican bobsleigh team. It’s been a cool experience that I’ll never forget.”  Li Jianrou, short track, China, on Weibo  “The Olympic Games is an amazing stage that hosts the dreams of all athletes. On this stage, everyone is a winner, no matter what the result. The finest moment of a person’s life is not when his dream comes true, but the journey to pursue the dream.”  OLYMPIC REVIEW 57  OLY040_P0055EDeng.indd 57  21/03/2014 14:27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Michael Christian Martinez Figure skating, Philippines  “The Olympic Village is like paradise. When you open the window you see the ocean and the stadiums and you feel the wind. It is so peaceful, so relaxing.”  Asiet Etyl Sochi 2014 volunteer from Russia  maria_mancina, Olympic fan on Instagram  “Can’t stop beaming! I’m at the Olympics!! #sochi2014”  “I really wanted to be a part of history and support the Russian team in Sochi. The whole Games have totally exceeded my expectations. We’re at the centre of the world right now – and people are watching everywhere. The most exciting thing has been to work with so many brilliant people. I’ve been keeping a diary of all the things that have happened to me, because I want to remember everything. It will be great to look back in 20 years and relive the Games again. The atmosphere has been so impressive. Everything that is happening is like a dream. It’s all about the athletes and the sport; that’s the beautiful thing about the Olympic Games. We’ve been getting together to watch the events after our shifts and even though we’re tired it has been an amazing experience.”  58 OLYMPIC REVIEW  OLY040_P0055EDeng.indd 58  21/03/2014 14:27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0059EDeng.indd 1  24/03/2014 16:57"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014  Rosalind Pearson Sochi 2014 volunteer from Great Britain “A lot of my friends volunteered for the London 2012 Games and I realised that I should have done it as well. I heard wonderful tales from them and felt enthused by that, so I thought I would apply to volunteer in Sochi. It’s been hard work, but it’s really enjoyable as well. It’s been really good to socialise with all the other volunteers and I’ve also been able to see some of the events. Being in the Iceberg Skating Palace and hearing the Russian fans nearly take the roof off with their cheering was amazing. It has way exceeded my expectations and I’m looking ahead to Rio now!”  Tatiana Kasimova Alex Ovechkin (@ovi8), ice hockey, Russia, on Twitter  “We’ve arrived at the Olympic Village! It’s incredible!!!”  Olympic fan from Russia  “We came here from Krasnodar because we wanted to feel the atmosphere in Sochi. I’ve never been to an Olympic Games before, but it’s really great and everyone is so friendly. All the venues look really good. We were very happy when Sochi won the Games and we knew then that we wanted to come and experience it for ourselves.”  60 OLYMPIC REVIEW  OLY040_P0060EDeng.indd 60  21/03/2014 14:29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Alexey Voevoda Two-man bobsleigh gold medallist, Russia “About 10 years ago, I wouldn’t have imagined that the Olympic Winter Games would take place here in my home town of Sochi. It was a town with only one road leading to the mountains where two cars would have trouble passing each other, but now it resembles a beautiful European city and I’m very happy. I am the only one from Russia’s Olympic team who is from Sochi. This is my home town and, as we say at home, even the walls are helping!”  Peter Crook Ski halfpipe, British Virgin Islands  Darya Domracheva Biathlon triple gold medallist, Belarus  “It feels amazing but I don’t think I will be able to feel all of my emotions until after the Games. I’m really glad to be here, with this amazing atmosphere and amazing support. The venue has been great; it’s really comfortable for the athletes and I think they did a great job.”  Brett Linden Olympic fan from the USA “We went to the 1996 Olympic Summer Games in Atlanta as a family and then we went to the Olympic Winter Games in Vancouver as well in 2010. We had a great experience there so we said we’re definitely going to Sochi as well. The atmosphere here is great – everyone has been so welcoming. The Park is huge and all the venues look amazing, plus you get a spectacular view of the mountains.”  “I am only the second athlete from the [British] Virgin Islands to come to the Winter Games, so that makes it an extra proud moment for me. It has been a huge honour to be able to represent my country here, and put it back on the charts for the Winter Games after 30 years. I am also part of the Olympic Solidarity programme and have had their support for the last 12 months. I was the flagbearer at the Opening Ceremony which was awesome.”  Adelina Sotnikova Figure skating gold medallist, Russia  “It was my dream to win in Sochi. I’m so happy that the Olympic Games were here in Russia because my fans are so supportive. Now I realise Russian support really is the best. I’ve never skated in front of that kind of audience before so I got a little nervous before I went out on the ice but I pulled myself together. I have competed in Russia a lot but to perform at the Olympic Games in Sochi is just something else – it is an incredible moment.”  OLYMPIC REVIEW 61  OLY040_P0060EDeng.indd 61  21/03/2014 14:29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "NEW EVENTS  62 OLYMPIC REVIEW  OLY040_P0062EDeng.indd 62  24/03/2014 16:35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "NEW EVENTS  Dazzling Debuts Twelve thrilling new events burst onto the Olympic landscape in Sochi, drawing praise from fans, officials and athletes alike, as Michael Stoneman reports  OLYMPIC REVIEW 63  OLY040_P0062EDeng.indd 63  24/03/2014 16:35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "NEW EVENTS  W  hether you are a fan of aweinspiring aerial exploits, adrenaline-fuelled racing, or simply good old-fashioned teamwork, there was sure to be a new Olympic event catching your eye at the Sochi 2014 Olympic Winter Games. Indeed, it was hard to miss the debut of snowboard slopestyle, with the “stoked” Sage Kotsenburg securing the very first gold medal of the Games as the event burst onto the Olympic programme in a blur of big airs, triple corks, tail grabs and 1,620-degree rotations. The gravity-defying spectacle – which sees athletes perform a series of technical aerial tricks as they descend a course consisting of rails and a variety of jumps – was joined by 11 other new events, with women's snowboard slopestyle being  joined by the mixed figure skating team competition, biathlon mixed relay, mixed luge team relay, men’s and women’s ski halfpipe, men’s and women’s ski slopestyle, men’s and women’s snowboard parallel slalom and women’s ski jumping also being held for the first time at a Winter Games. For 20-year-old US snowboarder Kotsenburg, the addition of slopestyle allowed him to realise a long-held ambition to compete on the Olympic stage. “It is a dream come true, for sure,” he says. “I’m from Park City, Utah, and having the Winter Games there in 2002 I watched a couple of events, and the highlight was seeing Ross Powers, Danny Kass and JJ Thomas sweep the halfpipe podium. And then 12 years later here we are, and I am sitting here with a gold medal.” ➤  Above The men’s snowboard slopestyle event made its debut in Sochi Left The Czech Republic's Marek Skala in the men's ski slopestyle Right Russia’s Stanislav Detkov and Austria’s Anton Unterkofler go head to head in the snowboard parallel slalom  64 OLYMPIC REVIEW  OLY040_P0062EDeng.indd 64  21/03/2014 14:14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0062EDeng.indd 65  21/03/2014 14:14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "NEW EVENTS  Other athletes were similarly thrilled to be at the Winter Games for the first time, giving them the chance to be part of history as their events made their Olympic debuts. “I didn’t think I would ever get to come to an Olympic Games. I’m just so stoked to be here and that everyone's going to see what slopestyle is all about,” said Canadian snowboarder Spencer O’Brien. “I think it’s something that all of us have been dreaming about for a long time. We all get to make history – whether we medal or not.”  Also writing their names into the record books were the world’s leading female ski jumpers. “Being here is history,” said US ski jumper Lindsey Van. “I want more people to see that women can ski jump.” The addition of team events in luge and figure skating, meanwhile, gave many athletes the chance to share Olympic glory with their compatriots for the first time. “We are normally individual athletes but now to become Olympic champions as a team, this is the greatest,” said ➤  “Being here is history. I want more people to see that women can ski jump” American ski jumper Lindsey Van (left)  Above and left The innovative team figure skating competition (above) made its debut as an Olympic event in Sochi, as did women’s ski jumping (left)  66 OLYMPIC REVIEW  OLY040_P0062EDeng.indd 66  21/03/2014 14:14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0067EDeng.indd 1  24/03/2014 16:59"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0068EDeng.indd 1  24/03/2014 17:00"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "NEW EVENTS  Germany’s Natalie Geisenberger, who was delighted to win the first ever luge relay gold medal. “One can only dream about it,” she adds. “You become a part of the sport’s history. We are very happy.” Kirsten Moore-Towers, who won silver in the first ever figure skating team event, was also pleased to be able to compete alongside her fellow Canadian skaters. “Usually we don't get an opportunity to be a team with the others,” she says. “This competition is different. When we heard about it we wanted to take part. “It’s brought us closer as a team, cheering everyone on. Someone showed us a video of all of us cheering Kevin [Reynolds] and it’s amazing to see how excited we were with every jump he landed. It was really amazing how it brought us all together.” The mixed biathlon relay, meanwhile, brought men and women into the same team for the first time at the Games,  which Tora Berger – a member of Norway’s gold medal-winning quartet – described as a “special” moment. According to IOC Sports Director Christophe Dubi, it is vital to regularly review and update the Olympic programme in order to keep the Games fresh and exciting for fans. “For the IOC, what is at play is to review the programme on a regular basis to make sure it remains relevant,” he says. “Of course, we need to preserve our history, but at the same time we have to remain relevant and make sure that we capture new audiences as well.” And those audiences seem impressed with what they saw in Sochi as well. “The new events have been really cool,” said Brett Linden, an American in the Olympic Park. “I’ve really enjoyed the freestyle skiing and the snowboarding. I think it’s great to get those types of events in the Games as it attracts a new generation of younger fans.”  Above The addition of the mixed relay gave male and female biathletes the chance to compete alongside each other for the first time at the Games  With Sochi 2014 enjoying record viewing figures around the world – both on television and digital platforms – it’s clear that millions of fans around the world shared Linden’s view. ■  New in Sochi • Biathlon mixed relay • Figure skating team event • Luge team relay • Ski halfpipe (men’s and women’s) • Ski slopestyle (men’s and women’s) • Snowboard slopestyle (men’s and women’s) • Snowboard parallel slalom (men’s and women’s) • Women’s ski jumping  OLYMPIC REVIEW 69  OLY040_P0069EDeng.indd 69  24/03/2014 17:04"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE FACES OF THE GAMES  OLY040_P0070EDeng.indd 70  21/03/2014 13:54"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE FACES OF THE GAMES  The Faces of the Games Although the athletes were the undoubted stars in Sochi, a huge team of Olympic volunteers was working tirelessly behind the scenes to help the Games run smoothly, while their positive experiences also made a mark on Russian society as a whole, writes Joanna Hunter  W  Left Volunteers played an essential role in the success of Sochi 2014, ensuring the Games ran smoothly with their untiring energy and welcoming attitude  ith their brightly coloured uniforms, broad smiles and eagerness to help, the 25,000-strong team of Sochi volunteers helped bring the 2014 Olympic Winter Games to life, while also ensuring that everything ran as smoothly and efficiently as possible. As with any edition of the Olympic Games, the efforts of the volunteers – while perhaps not as celebrated as those of the athletes – were just as integral to the overall success of Sochi 2014, helping to create what organisers described as a “special atmosphere” during the Games. Volunteering has, of course, long been a core part of the Olympic Games, ever since it was first introduced at London in 1948. Whether it was the  2,191 volunteers at the Helsinki Olympic Games in 1952, or the 60,000 at the London Games in 2012, volunteers from around the world have been essential to the success of every Games. And Sochi was no exception. Here, the 25,000 members of Komanda 2014 – or Team 2014 – as they were known, worked on everything from transport to technology to working at the Olympic ceremonies. An achievement certainly, but even more so when you consider nothing on this scale had ever been attempted in Russia before. As Dmitry Chernyshenko, President of the Sochi 2014 Organising Committee, put it, “When Sochi began the bidding process in 2005, the concept of volunteering simply did not exist in Russia.”  To address this, the Russian parliament formalised the “Games volunteer” concept into law, while the Sochi 2014 Organising Committee mounted a nationwide volunteer recruitment campaign, with 26 Volunteer Centres set up across the country tasked with changing the perception of volunteering and highlighting opportunities for those who wanted to get involved. “Only 3% of the Russian population was involved in the volunteer movement five years ago,” explains Marina Pochinok, Workforce Vice President of the Sochi 2014 Organising Committee. “There was no legal definition of the word ‘volunteer,’ and we had to start from scratch to create the programme’s basic platform.” ➤  OLYMPIC REVIEW 71  OLY040_P0071EDeng.indd 71  24/03/2014 15:00"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE FACES OF THE GAMES  “82% of selected applicants were aged between 18 and 30, making for an average volunteer age of just 23”  With a total of 200,000 applicants, it was an enormous success. Volunteers flocked from as far afield as St Petersburg, Vladivostok, Arkhangelsk and Omsk, representing every region of Russia. This also meant that, for the first time at an Olympic Games, 95% of the workforce came from outside the region of the host city. A further 1,800 – representing some 66 nations – came from outside Russia. Of the applicants chosen, 82% were aged between 18 and 30, making for an average volunteer age of just 23, compared with 44 in London and 45 in Vancouver. Interestingly, more than 60% of the volunteer force were female, and 54 families were also represented – volunteers signed up with their brothers and sisters, husbands and wives, or parents with their children.  Training for the 25,000 selected volunteers began in March 2013. There were three stages: stage one was a three-day general training course held at each regional Volunteer Centre, which covered the history and values of the Olympic Games, details of the Olympic sports and introduced volunteers to the sports tracks and venues located in the Sochi Coastal and Mountain clusters. Stage two was a further three-day course where volunteers got to learn more about their individual roles, and stage three, held immediately before the Games, allowed the volunteers to meet the venue teams and familiarise themselves with their location. And the intensive training was a worthwhile investment, with the volunteers receiving widespread praise for their efforts during the Games.  Above (clockwise from left) Brightly clad volunteers were a common sight in Sochi; from site maintenance to giving directions, the Games could not have taken place without their help  72 OLYMPIC REVIEW  OLY040_P0070EDeng.indd 72  21/03/2014 13:54"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE FACES OF THE GAMES  “The volunteers are the people who bring the beauty and special atmosphere to the Games,” says Pochinok. “These are special people who can radiate this atmosphere to the public and really create a very successful and very friendly Games.” The volunteers themselves were also delighted to be making such significant contributions to the overall success of Sochi 2014. “I am really happy that I'm here,” said Natalia Salmina, a medical volunteer from Ufa. “Of course all of us are very happy to make these Games happen. All of us work very hard and do everything we can to make the competitions you see run smoothly. We are all really happy to be part of this great event, the Olympic Games.” Oksana Shulzhenko, a volunteer from Kharkov, Ukraine, added: “Even before ➤  OLYMPIC REVIEW 73  OLY040_P0070EDeng.indd 73  21/03/2014 13:54"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0074EDeng.indd 1  24/03/2014 17:02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE FACES OF THE GAMES  Above and right Volunteers underwent an intensive training programme that enabled them to provide vital assistance throughout the Games  you set your foot inside a sports venue, you really feel that the air is filled with the Olympic spirit! It is truly inspiring, it gives you an incredible energy, and I feel that I will come home a different person.” But it’s not only the volunteers in Sochi who have benefited from the Olympic volunteer initiative – its influence can be felt across Russian society. By the end of 2012, around 2,800 projects involving volunteers of the Games had already been successfully implemented across the country, with Russia climbing to eighth place in the 2012 World Giving Index, which measures the number of people involved in voluntary work. “Three years ago, people reacted sceptically to the word ‘volunteer,’ as it was new to the Russian language, but now this word has only positive connotations,” explains Alexander Pflyuk, a volunteer team leader from Siberia, who, along with his team, travelled for three days to be part  of the Games. “Young people are proud to be part of the volunteer movement.” It is this sea change in Russian attitudes that Dmitry Chernyshenko believes will be one of the most important long-term benefits of the Sochi 2014 Winter Games. “Our ultimate goal is to inspire millions to join the revived volunteer movement across Russia, making a meaningful contribution to society that will leave a lasting legacy for generations to come,” he says. If the efforts of the Sochi 2014 volunteers are anything to go by, then they are already on the right track. ■  “The volunteers are the people who bring the beauty and special atmosphere to the Games” Marina Pochinok OLYMPIC REVIEW 75  OLY040_P0075EDeng.indd 75  21/03/2014 13:55"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "MY GAMES  INTERVIEW: MICHAEL STONEMAN  MY GAMES JEAN-CLAUDE KILLY FRANCE’S JEAN-CLAUDE KILLY DELIGHTED THE HOME CROWD AT THE 1968 WINTER GAMES IN GRENOBLE BY WINNING ALL THREE ALPINE SKIING EVENTS TO MATCH THE INCREDIBLE 1956 ACHIEVEMENT OF AUSTRIA’S TONI SAILER  M  y first Games were 50 years ago, in Innsbruck in 1964, but I still remember them. I didn’t do very well, so they’re not particularly fond memories, but it was still an incredible experience to participate at the Games. There are millions of children, all throughout the world, who dream of participating in the Games, but only a few who qualify to go. Just being there is, in itself, an amazing achievement. It’s a dream come true. The size of the Games was incredible. To a young kid, it was unbelievable. You would meet people that you would never meet otherwise, from countries that you didn’t even know existed – it made it all totally special. I didn’t take part in the Opening Ceremony, as I had the downhill the next day, and I realised afterwards that it was a mistake not to be there. Looking back, I basically wasn’t ready to perform at the Olympic level in 1964, but it helped me prepare for my next Games. Without the 1964 Games, I wouldn’t have  been able to achieve what I did in 1968. In Grenoble, I made sure I was in the Opening Ceremony, because I missed too much by not being there in Innsbruck. I didn’t want to make that mistake again and it was beautiful. The 1968 Games are difficult for me to describe. I won two gold medals in the first few days of the Games and then suddenly I was at the centre of everything. We even needed gendarmes where we were staying because there was so much interest, especially with the Games being in France. Charles de Gaulle had worked hard to bring the Games to France and I had wanted to be successful for him and my country. I had not been doing well in the downhill before the Games; for some reason I just couldn’t win any races, so I was very focused on what I had to do because I knew it was going to be very difficult. In the Games, you never know what is going to happen, so winning the downhill by eight hundredths of a second was incredible. The weather was very bad and  the pressure was high because it was the first event. For me, the giant slalom was the easiest race to win because it was my favourite event. Then, the slalom was very difficult because if you look at previous Games, it is not usually the favourite who wins. We had two runs in thick fog and it was very difficult. I skied as best as I could; I went all out and just hoped! And then, voilà! I was very good friends with Toni Sailer and he gave me some great advice a year before the Games. He said I shouldn’t ski in the last few days leading up to the Games, because I should be arriving in Grenoble very fresh, very strong and well rested. I did exactly what he said. At 24, it was just an incredible experience and at the end of the Games, I announced my retirement from competition. ■ GRENOBLE 1968 Gold: Downhill Gold: Giant Slalom Gold: Slalom  76 OLYMPIC REVIEW  OLY040_P0076EDeng.indd 76  21/03/2014 14:16"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0076EDeng.indd 77  21/03/2014 14:16"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "With the Olympic Museum reopening its doors following extensive renovations, Olympic Review looks at how the new exhibition areas and ultra-modern presentation techniques will allow the museum to tell the history of Olympism and the Olympic Games like never before. .  Olympic Review has a cover price of 10 Swiss Francs per issue (not including postage). To subscribe to the magazine, please tick your preferred language version below (French/English/Spanish) and choose one of the three payment methods.  ■ FRENCH ■ ENGLISH ■ SPANISH  To subscribe to Olympic Review for one year please tick one of the boxes below to indicate your mailing address. The cost of an annual subscription (four issues) is:  ■ 50 CHF - Mailing address in EUROPE ■ 70 CHF - Mailing address in REST OF WORLD The subscription fee will be sent by (please tick one box):  Please send the subscription form below to: Olympic Review Subscriptions, Château de Vidy, c. p. 356, 1007 Lausanne, Switzerland; Fax + 41 21 621 6356  FIRST NAME LAST NAME ORGANISATION ADDRESS  ■ Bank transfer to the IOC account 243-312883.03Q, to UBS SA, 1002 Lausanne (BIC: UBSWCHZH80A IBAN CH41 0024 3243 3128 8303 Q); ■ International postal order in Swiss Francs addressed to the Olympic Museum Lausanne, Publications service, P.O. Box 1121, 1001 Lausanne, Switzerland. ■ Visa credit card only (please indicate the card holder, card number and expiry date below and post to the address above).  CARD HOLDER VISA CARD NO  POST/ZIP CODE  EXPIRY DATE  COUNTRY  SIGNATURE  E-MAIL  78 OLYMPIC REVIEW  OLY040_P0078EDeng.indd 78  21/03/2014 14:55"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0079EDeng.indd 1  24/03/2014 17:07"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0080EDeng.indd 1  24/03/2014 17:09"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OBITUARIES  PYOTR BOLOTNIKOV  IMRE NAGY Hungarian pentathlete Imre Nagy, who won team gold and individual silver at the 1960 Olympic Games in Rome, as well as a team bronze four years later in Tokyo, has died at the age of 80. A three-time medallist at the World Championships, Nagy was also the coach of the Hungarian team. Within the International Modern Pentathlon Union (UIPM), he was Deputy Secretary General, a member of the Board and the Cultural Commission, and an honorary member. He was also greatly involved with the Hungarian Olympic Academy.  SOVIET LONG DISTANCE RUNNER WHO WON 10,000M GOLD AT THE 1960 OLYMPIC GAMES IN ROME  Former long distance runner Pyotr Bolotnikov (right), who won Olympic 10,000m gold for the Soviet Union at the 1960 Games in Rome, has died at the age of 83. Bolotnikov first competed in the 1956 Olympic Games before winning gold in Rome four years later. He also broke the 10,000m world record in October 1960, before repeating the feat in August 1962, just two weeks before winning gold at the European Championships.  GYULA TÖRÖK  FRANZ GABL THE FIRST AUSTRIAN TO WIN AN OLYMPIC ALPINE SKIING MEDAL  Austrian Olympic skier Franz Gabl (below, right) has died, aged 93. Born in Anton am Arlberg, Gabl was the first Austrian to win an Alpine skiing Olympic medal – a silver in the downhill at the Games in St Moritz in 1948. After retiring from competition, Gabl coached the Canadian women’s Olympic ski team for the 1952 Games, then the men’s team four years later.  Former Olympic boxing champion Gyula Török of Hungary has passed away at the age of 75. Török was a member of the national squad during one of the golden eras of Hungarian boxing between 1958 and 1964. He won a silver medal at the 1959 European Boxing Championships, before claiming Olympic flyweight gold at Rome 1960. He went on to coach in Hungary and was assistant coach of the national boxing squad from 1993 until his retirement. UROŠ MAROVIC Former water polo player Uroš Marovic, who won Olympic gold with Yugoslavia at the 1968 Games in Mexico City, has died aged 67. He won 203 caps for the national team and scored 198 goals. As well as Olympic gold in 1968, Marovic also won two European bronze medals, in 1970 and 1974. Marovic will be remembered for scoring a decisive goal in overtime of the Olympic gold medal match against the Soviet Union.  OLYMPIC REVIEW 81  OLY040_P0081EDeng.indd 81  21/03/2014 15:11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "DIETER SPEER THE OLYMPIC SPIRIT  When the Soviet Union’s Alexander Tikhonov broke his ski during the first leg of the 4×7.5km biathlon relay at the Sapporo 1972 Winter Games, it looked like his hopes of defending the Olympic title he and his team-mates had won four years earlier had ended. East Germany’s Dieter Speer (pictured) proved to be an unlikely saviour, however, as he handed Tikhonov one of his own reserve skis, enabling his Soviet rival to rejoin the race. Tikhonov and his teammates went on to secure a second successive gold, while Speer’s East German team won bronze.  OLY040_P0082EDeng.indd 82  21/03/2014 15:14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BEST OF SOCHI 2014 NTSC + PAL DVD © IOC 2014  BEST OF SOCHI 2014 DISCOVER OR RELIVE THE HIGHLIGHTS OF THE 2014 WINTER OLYMPIC GAMES IN SOCHI  www.olympic.org www.youtube.com/olympics  OLY040_P0083EDeng.indd 83  21/03/2014 15:13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLY040_P0084EDeng.indd 1  24/03/2014 17:11"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-159440454-25',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T53c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tGyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0738437472970f0b912d.js